import { useSignal, useSignals } from '@preact/signals-react/runtime'
import * as $ from '../../signal/searchbox'
import { StarsIcon } from '../Icons/Icons'
import styles from './ShowSummaryCTA.module.css'

type ShowSummaryCTAProps = {
  show: boolean
}

function trimSearchTerm(searchTerm: string, maxLength = 40) {
  if (!searchTerm) return ''

  return `"${searchTerm.length > maxLength ? `${searchTerm.slice(0, maxLength)}...` : searchTerm}"`
}

export function ShowSummaryCTA(props: ShowSummaryCTAProps) {
  useSignals()
  const searchInput = useSignal($.searchTerm).value

  function openSummary() {
    if (searchInput.value) {
      $.getSummary({
        term: searchInput.value
      })
    }

    $.isSummaryExpanded.value = true
    $.isSummaryClamped.value = false
  }

  if (!props.show) {
    return null
  }

  const buttonContent = searchInput.value
    ? `Get a summary or ask about ${trimSearchTerm(searchInput.value as string)}`
    : 'Ask anything to Orama AI'

  return (
    <div className={styles.summary__cta__wrapper}>
      <button type="button" className={styles.summary__cta__container} onClick={openSummary}>
        <StarsIcon className={styles.summary__stars__icon} />
        <span className={styles.summary__cta__text}>{buttonContent}</span>
      </button>
    </div>
  )
}
